<template>
  <div id="home">
    <div class="ContentContainer">
      <div v-if="isReady && incognitoMode" class="row">
        <div class="col">
          <Portfolio />
        </div>
      </div>
      <div class="row" :style="isReady ? '' : 'opacity: 20%;'">
        <div class="col-12 col-sm-6">
          <Evaluation v-if="!incognitoMode" />
          <ProfitLosses />
          <!--
          <EvaluationPerExchange
            v-if="
              !profitlossMode && !incognitoMode && showValuationsPerExchange
            "
          />
          <b-button
            v-if="
              !profitlossMode && !incognitoMode && !showValuationsPerExchange
            "
            variant="link"
            size="sm"
            class="text-secondary mt-2 pl-0"
            @click="toggleShowValuationsPerExchange"
          >
            {{ $t("exchange.home_show_valuation_per_exchange") }}
            <i class="fa fa-eye ml-2"></i>
          </b-button>
          -->
          <LastUpdated
            v-if="true"
            class="last-update text-left"
          />
        </div>
        <div
          v-if="!profitlossMode || !profitlossShowHistory"
          class="col-12 col-sm-6 px-0 px-sm-3"
        >
          <Chart />
          <LastUpdated
            v-if="
              false
            "
            class="last-update"
          />
        </div>
      </div>
    </div>

    <div v-if="isReady" id="profitlossMode_switcher" class="mt-4 text-center">
      <a
        href="/"
        class="btn px-3 py-2 text-nowrap border-ni mr-3"
        :class="[!profitlossMode ? 'btn-info' : 'btn-outline-info']"
        @click.prevent="setProfitlossMode(false)"
        >{{ $t("assets.your_assets") + " " + $t("profitloss.mode") }}</a
      >
      <a
        href="/"
        class="btn px-3 py-2 text-nowrap border-ni"
        :class="[profitlossMode ? 'btn-info' : 'btn-outline-info']"
        @click.prevent="setProfitlossMode(true)"
        >{{ $t("profitloss.portfolio") + " " + $t("profitloss.mode") }}</a
      >
    </div>
    <div v-else class="mt-4" />

    <Assets v-if="isReady && !profitlossMode" class="mt-4" />

    <ProfitLossPortfolio v-if="isReady && profitlossMode" class="mt-4" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Chart from "../specials/AssetValueShareChartContainer.vue";
import Evaluation from "./../Evaluation.vue";
import Portfolio from "./../Portfolio.vue";
import ProfitLosses from "./../ProfitLosses.vue";
// import EvaluationPerExchange from "./../EvaluationPerExchange.vue";
import LastUpdated from "./../LastUpdated.vue";
import Assets from "./../Assets.vue";
import ProfitLossPortfolio from "./../ProfitLossPortfolio.vue";

export default {
  name: "Home",
  components: {
    Chart,
    Evaluation,
    Portfolio,
    ProfitLosses,
    // EvaluationPerExchange,
    LastUpdated,
    Assets,
    ProfitLossPortfolio,
  },
  computed: {
    ...mapGetters({
      incognitoMode: "settings/incognitoMode",
      // showValuationsPerExchange: "settings/showValuationsPerExchange",
      profitlossMode: "settings/profitlossMode",
      profitlossShowHistory: "profitloss/showHistory",
      isReady: "coinmarketcap/isReady",
    }),
  },
  methods: {
    // toggleShowValuationsPerExchange() {
    //   this.setSetting({ setting: "showValuationsPerExchange", value: true });
    // },
    setProfitlossMode(value) {
      this.setSetting({ setting: "profitlossMode", value });
    },
    ...mapActions({
      setSetting: "settings/setSetting",
    }),
  },
};
</script>

<style lang="scss" scoped>
@import "~@/scss/variables";
@import "~@/scss/mixins";

#home {
  position: relative;
}

.AssetsHeader {
  margin-top: 120px;
  position: relative;
}

.AssetsHeader__Nav {
  position: absolute;
}

.last-update {
  color: #8da3ad;
  margin: 30px 0 0;
  text-align: right;
}

.CurrentVersio {
  font-size: 16px;
  margin-top: -25px;
  text-align: right;
  @include breakpoint-manual(max-width, $break-small - 1px) {
    font-size: 14px;
    text-align: center;
  }
}
</style>
